/**
 * 
 * @returns 
 * @description: funcionalidades utiles en el front
 */


const maskID = '9161-';
const mascara = 'Account ID: '+maskID;

const  detectIsMobile = ()=>{
    if (
        (navigator.userAgent.match("Android")) ||
        (navigator.userAgent.match("webOS")) ||
        (navigator.userAgent.match("iPhone")) ||
        (navigator.userAgent.match("iPod")) ||
        (navigator.userAgent.match("iPad")) ||
        (navigator.userAgent.match("BlackBerry"))
    ){ return true
    } else {return false}
}

const autoFillLeft =(number,size)=>{
    const paddedNumber = number.toString().padStart(size, '0');
    return paddedNumber;
}

const estandariza = (number)=>{
    return autoFillLeft(number,6) // 6 queda fijos siempre.
}

// Tener cuidado que puede utilizarse como identificador secundario
// Retorna el Account Id, ID del cliente
const formatIdClient =(number)=>{
    let salida = mascara + estandariza(number);
    return salida;
}




export const Util =  {
    autoFillLeft:autoFillLeft,
    detectIsMobile: detectIsMobile,
    formatIdClient: formatIdClient,
    maskID: maskID,
    estandariza: estandariza,
}